import { render, staticRenderFns } from "./sseNotification.vue?vue&type=template&id=5307b55d"
import script from "./sseNotification.vue?vue&type=script&lang=js"
export * from "./sseNotification.vue?vue&type=script&lang=js"
import style0 from "./sseNotification.vue?vue&type=style&index=0&id=5307b55d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports